<template>
  <div class="">
    <modal
      v-if="modalCreate.show"
      @close="closeModal"
      :clickOutsideToClose="true"
    >
      <template slot="header">
        <h3 v-if="modalData.success" class="modal-title modal-success-title">
          {{ modalData.title ? modalData.title : $t("common.success") }}
        </h3>
        <h3 v-else class="modal-title modal-failure-title">
          {{ modalData.title ? modalData.title : $t("common.failure") }}
        </h3>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeModal"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div class="md-layout-item md-size-100">
          <div class="md-layout">
            <md-icon v-if="modalData.success" class="success-icon"
              >check_circle</md-icon
            >
            <md-icon v-else class="error-icon">error</md-icon>
          </div>
        </div>
        <br />
        <div class="md-layout-item md-size-100">
          <div class="md-layout">
            <div class="content">{{ modalData.content }}</div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "@/components";

export default {
  name: "ResultModal",
  data() {
    return {};
  },
  components: {
    Modal
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    }
  },
  props: ["modalCreate", "modalData"],
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.label-design {
  font-size: 19px;
  font-weight: 700;
  margin-top: 28px;
  margin-bottom: 28px;
}

.md-menu-content-bottom-start {
  z-index: 90000000 !important;
}

.content {
  text-align: center;
  color: black;
  font-size: 18px;
  font-weight: bold;
}

.success-icon {
  font-size: 40px !important;
  color: #66bb6a !important;
}

.error-icon {
  font-size: 40px !important;
  color: #e44e4e !important;
}

.modal-success-title {
  color: #66bb6a;
}

.modal-failure-title {
  color: #e44e4e;
}
</style>
